// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__34Bs8","alertIcon":"ConfirmModal_alertIcon__3m8-V"};